import { DimensionValueSet } from "@/lib/dimensions";
import { compareDimensionValueSets } from "@/lib/dimensions/helpers";

import { TileInfo } from "./tiled-deck-gl-layer";

type _GetTileImageProps = {
  tile: TileInfo;
  dimensionValues: DimensionValueSet;
};

type _Record = {
  dimensionValues: DimensionValueSet;
  image: HTMLImageElement;
};

export class TileImageStore {
  private store = {} as {
    [tileId: string]: _Record[];
  };

  getTileImage({ tile, dimensionValues }: _GetTileImageProps) {
    const record = this.store[tile.id]?.find((record) => {
      return compareDimensionValueSets(dimensionValues, record.dimensionValues);
    });

    return record?.image;
  }

  storeTileImage(image: HTMLImageElement, { tile, dimensionValues }: _GetTileImageProps) {
    if (this.hasTileImage({ tile, dimensionValues })) return;

    this.store[tile.id] ||= [];
    this.store[tile.id].push({ image, dimensionValues });
  }

  hasTileImage(props: _GetTileImageProps) {
    return !!this.getTileImage(props);
  }

  purgeTile(tile: TileInfo) {
    // NOTE
    // We assume it's OK to completely discard previously fetched tile images
    // because we assume that when this tile comes back into view that the
    // previously fetched image is in the browser HTTP cache. In this case
    // simply getting that image back from the browser cache should only take a
    // couple of miliseconds.
    delete this.store[tile.id];
  }
}
